export enum BrowserLanguage {
    en = "en-US",
    he = "he",
    ar = "ar",
    ru = "ru",
}

